import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import logout from '@design-system/Assets/logout.svg';
import { Link } from 'react-router-dom';
import basket from '@design-system/Assets/basket_icon.png';
import profile from '@design-system/Assets/profile_icon.png';

const Container = styled.div`
  padding: 16px;
  position: relative;
  height: 95vh;

  .body {
    nav {
      display: flex;
      gap: 4px;
      margin-top: 28px;
      flex-direction: column;

      .content {
        display: flex;
        gap: 17px;
        align-items: center;
        height: 44px;
      }

      h4 {
        margin: 0;
        padding: 0;
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        display: block;
        text-transform: capitalize;
      }

      .alert {
        position: absolute;
        z-index: 1;
        background: #d92d20;
        width: 15px;
        height: 15px;
        display: grid;
        place-items: center;
        font-size: 10px;
        font-weight: 600;
        border: 1px solid #fff;
        border-radius: 100%;
        color: #fff;
        margin-left: 12px;
        margin-top: -17px;
      }
    }
  }
`;

const Footer = styled.div`
  position: absolute;
  bottom: 0;
  margin: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  display: block;

  .content {
    border-top: 1px solid #e0e0e0;
    display: flex;
    justify-content: space-between;
    padding-top: 24px;
    padding-bottom: 24px;
    margin-left: 16px;
    margin-right: 16px;

    h3 {
      margin: 0;
      color: #333333;
      font-size: 16px;
      font-weight: 700;
    }

    h4 {
      margin: 0;
      color: #bdbdbd;
      font-size: 14px;
      font-weight: 400;
    }
  }
`;
const Mobile = ({ user, toggle, total }) => {
  const token = localStorage.getItem('x-access-token');

  // const logOutUser = () => {

  // }
  return (
    <Container>
      <div className="body">
        <nav>
          <Link to="/basket" className="content" onClick={toggle}>
            {total >= 1 && <div className="alert"> {total} </div>}
            <img src={basket} alt="basket_icon" />
            <h4>Basket</h4>
          </Link>

          {user.email_verified && token ? (
            <Link to="/settings/profile" className="content" onClick={toggle}>
              <img src={profile} alt="profile_icon" />
              <h4>Profile</h4>
            </Link>
          ) : (
            <Link to="/login" className="content" onClick={toggle}>
              <img src={profile} alt="profile_icon" />
              <h4>Login</h4>
            </Link>
          )}
        </nav>
      </div>
      {Object.keys(user).length >= 1 && (
        <Footer>
          <div className="content">
            <div>
              <h3>{`${user?.first_name} ${user?.last_name}`}</h3>
              <h4>{user?.email}</h4>
            </div>
            <Link to="/logout">
              <img src={logout} alt="logout" />
            </Link>
          </div>
        </Footer>
      )}
    </Container>
  );
};

export default Mobile;

Mobile.propTypes = {
  user: PropTypes.object.isRequired,
  toggle: PropTypes.func,
  total: PropTypes.number,
};

Mobile.defaultProps = {
  toggle: () => {},
  total: 0,
};
